import { BankIdWidgetDto } from "@api-types/integrations";
import { MitIdWidgetDto } from "@api-types/integrations/MitIdWidgetDto";
import { Lookup, LookupItem } from "@data-types";
import { GamingLimitDataType } from "@data-types/membership/registration";
import { logger } from "@utils/logger/logger";
import { isBoolean } from "lodash";

export function validateLookupResponse(
	response: Lookup<LookupItem> | undefined,
	name: string
) {
	if (!response || !response.item) {
		logger.logError(
			new Error("Response or response.item is undefined/null")
		);
		return false;
	}

	if (response.item.length < 1 || !Array.isArray(response.item)) {
		logger.logError(new Error("Response.item is empty or not an array"));
		return false;
	}

	return true;
}

export function validatePartnerLookupResponse(
	response: LookupItem[] | undefined,
	name: string
) {
	if (!response) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (response.length < 1 || !Array.isArray(response)) {
		logger.logError(new Error("Response is empty or not an array"));
		return false;
	}

	return true;
}

export function validateMitIdProcessResponse(
	response: MitIdWidgetDto | undefined,
	gp_location: string
) {
	if (!response || response == null) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (!response.loginHash || !response.loginUrl) {
		logger.logError(
			new Error("Response loginHash or loginUrl is undefined/null")
		);
		return false;
	}

	return true;
}

export function validateBankIdProcessResponse(
	response: BankIdWidgetDto | undefined,
	gp_location: string
) {
	if (!response || response == null) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (!response.redirectUrl) {
		logger.logError(new Error("RedirectUrl is undefined/null"));
		return false;
	}

	return true;
}

export function validateTwGamingLookupsResponse(
	response: GamingLimitDataType | undefined
) {
	if (!response) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (!response.maxLimit || !response.minLimit) {
		logger.logError(
			new Error(
				"Response.minLimit or Response.maxLimit is undefined/null"
			)
		);
		return false;
	}

	return true;
}

export function validateBooleanResponse(
	data: any | undefined,
	gp_location: string
): boolean {
	if (data == undefined) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (!isBoolean(data)) {
		logger.logError(new Error("Response is not boolean"));
		return false;
	}

	return data;
}

export function validatePasswordSimilarityResponse(
	data: boolean | { error: any; isSuccess: boolean } | undefined,
	gp_location: string
): boolean {
	if (data == undefined) {
		logger.logError(new Error("Response is undefined/null"));
		return false;
	}

	if (typeof data == "object" && "isSuccess" in data) {
		if (data.isSuccess == undefined || !isBoolean(data.isSuccess)) {
			logger.logError(
				new Error("Response.isSuccess is undefined/null or not boolean")
			);
			return false;
		}

		return data.isSuccess;
	}

	return data;
}
